<script>
import _weChatAuth from '@/plugins/auth/wechatAuth.js'
import _qqAuth from '@/plugins/auth/qqAuth.js'
import client from '@/client/'
import { formatDate } from '@/utils/shared'
import * as LoginHandler from '@/services/login/loginHandler.js'
import { WECHAT_LOGIN_CONF, QQ_LOGIN_CONF } from '@/config/config'
import { getOneDayFreeVip } from '@/api/vip'
import {
  saveToken,
  saveUserInfo
} from '@/utils/cache'
import { REPORT_LOGIN_TYPE, OCPC_CONVERT_TYPE } from '@/config/dataMap'
import { updateConvertData } from '@/api/login'

/** 登录类型 */
const LOGIN_TYPE_MAP = {
  /** 微信登录 */
  WeChat: 3,
  /** QQ登录 */
  QQ: 4
}

/** 登录上报 */
const reportResult = ({ result = 0, reason = '', login_type = 1, openid = '', vip_status = 0, is_vip = 0 }) => {
  const show_time = formatDate(new Date())

  client.login.REPORT.reportLoginPageResult({
    result,
    reason,
    login_type,
    openid,
    vip_status,
    show_time,
    is_vip,
  })
}

/** 关闭Window */
const closeWindow = async () => {
  const res = await client.common.API.client_checkMethod('closeWindow')

  if (res.result) {
    client.common.API.client_closeWindow()
  } else {
    window.close()
  }
}

/** 登录成功 */
const loginSuccess = async ({ data, id, stopWinClose, next, reportLoginType }) => {
  reportResult({
    result: 1,
    reason: '',
    login_type: reportLoginType,
    openid: data.user_info.open_id,
    vip_status: data.user_info.is_continuous === '1' ? 1 : 2,
    is_vip: data.user_info.vip_type === 0 ? 0 : 1,
  })

  saveToken(data.token)
  saveUserInfo(data.user_info)
  try {
    const res = await client.common.API.getOcpcUrl()
    await updateConvertData({
      conversion_info: {
        long_code: res.logidUrl,
        convert_type: OCPC_CONVERT_TYPE.LOGIN,
        user_type: res.userType > 0 ? res.userType : 1,
      }
    })
    await getOneDayFreeVip()
  } catch (e) {
    closeWindow()
  }

  // 通过参数判断是否需要通知客户端刷新页面（老会员绑定流程不需要）
  if (!stopWinClose || stopWinClose == '0') {
    client.common.API.client_winclose({
      token: data.token,
      open_id: data.user_info.open_id,
      type: id === LOGIN_TYPE_MAP.WeChat ? 1 : 2,
    })
  }
  closeWindow()
}

/** 登录限制 */
const loginLimit = ({ data, id, stopWinClose, next, res, reportLoginType }) => {
  reportResult({
    result: 2,
    reason: '登录设备限制',
    login_type: reportLoginType,
    openid: '',
    vip_status: 0,
  })

  next((vm) => {
    vm.$toast(
      `登录设备达到上限，同一会员账号允许最多在${res.limit}台设备登录`,
      {
        duration: 2000,
        callback: function () {
          closeWindow()
          // 客户端弹出登录受限框
          LoginHandler.openDeviceAdmin(data.token, data.user_info.open_id)
        },
      }
    )
  })
}

/** 登录异常 */
const loginException = ({ data, id, stopWinClose, next, reportLoginType }) => {
  reportResult({
    result: 2,
    reason: '登录异常',
    login_type: reportLoginType,
    openid: '',
    vip_status: 0,
  })

  next((vm) => {
    vm.$toast('登录异常，请重试', {
      callback: function () {
        closeWindow()
      },
    })
  })
}

/** 账号已经被迁移 */
const haveMigration = () => {
  client.common.API.client_openOptionWindow({
    url: `${window.location.origin}/${buildChannel}/upgrade-client`,
    width: 400,
    height: 180,
    open_web: 'upgrade-client_one'
  })
  closeWindow()
}

/** 登录 */
const login = (to, next, code) => {
  reportResult({
    result: 3,
    reason: '',
    login_type: REPORT_LOGIN_TYPE.wechat,
  })
  const stopWinClose = to.query.stopWinClose
  const id = Number(to.params.id) // to.params.id -- 3 微信登录 4 QQ登录
  const queryLoginType = to.query.report_login_type || 2
  const reportLoginType = id === LOGIN_TYPE_MAP.WeChat ? +queryLoginType : 3

  // 微信登录回调 拿到code去后台获取用户信息
  LoginHandler.login({
    login_type: 3,
    plat_token: code,
    plat: id === LOGIN_TYPE_MAP.WeChat ? 170 : 169,
  }).then((res) => {
    const ret = Number(res.resp_common.ret)

    // 先处理特殊状态码
    if (ret === 5904001) {
      haveMigration()
      return
    }

    const data = res.data
    reportResult({
      result: 4,
      reason: '',
      login_type: REPORT_LOGIN_TYPE.wechat,
      openid: data.user_info.open_id,
      vip_status: data.user_info.is_continuous === '1' ? 1 : 2,
      is_vip: data.user_info.vip_type === 0 ? 0 : 1,
    })
    const param = { data, id, stopWinClose, next, res, reportLoginType }

    const statusCodeMap = {
      0: () => { loginSuccess(param) },
      5903006: () => { loginLimit(param) }
    }

    if (statusCodeMap[ret]) {
      statusCodeMap[ret]()
      return
    }

    loginException(param)
  }).catch(() => {
    loginException({ id, next })
  })
}

export default {
  beforeRouteEnter(to, comefrom, next) {
    const weChatAuth = new _weChatAuth(WECHAT_LOGIN_CONF)
    const qqAuth = new _qqAuth(QQ_LOGIN_CONF)
    const jump = to.query.jump
    const id = Number(to.params.id) // to.params.id -- 3 微信登录 4 QQ登录

    // 中间授权页，用于 跳转微信 和 QQ登录授权 和 回调
    if (to.name == 'auth') {
      // 获取微信回调的code, http://newvip.ijinshan.com/#/auth/3?code=123
      let code = to.query.code

      if (!code) {
        // QQ回调的access_token
        code = qqAuth.getUrlAccessToken(to.hash)

        // 针对QQ中间代理页回调，特殊处理了access_token(更新为token)
        if (!code) {
          code = to.query.token
        }
      }

      // 不管是否登录状态都可以进登录页
      if (id === LOGIN_TYPE_MAP.WeChat || id === LOGIN_TYPE_MAP.QQ) {
        if (code) {
          login(to, next, code)
          return false
        }

        jump && (id === LOGIN_TYPE_MAP.WeChat ? weChatAuth.openAuthPage() : qqAuth.openAuthPage())
      }
    } else if (to.name === 'payStatus') {
      console.log('pay success')
      closeWindow()
    }
  },

  render(h) {
    return null
  },
}
</script>
